import { api_base } from '../api';
import {
	getShoppingCart,
	getWishList,
	setBillingInfo,
	getUsers,
	getOrders,
	getSliders,
	logoutUser,
	getContractProjects,
	getUserOrders,
	getUserPurchaseOrders
} from '../actions';
import { router } from '../../routes/routes';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import * as types from '../mutation-types';
import Store from '../store';

export const Users = {
	// ---- GET ALL ----

	get(page = 1, data, cb) {
		$.ajax({
			url: api_base + '/admin/users?page=' + page,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					Users.get(++page, cb);
				}
			},

			error: function (err) {
				// console.log(err);
			}
		});
	},

	// ---- GET BY ID ----

	getById(user, id, cb) {
		let users = Store.state.users

		if (!users.length) {
			$.ajax({
				url: api_base + '/admin/users/' + id,
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + user.token
				},

				success: function (res) {
					cb(res);
				},

				error: function (err) {
					// console.log(err);
				}
			});
		} else {
			for (let i = 0; i < users.length; i++) {
				if (users[i].id == id) {
					return cb(users[i])
				}
			}
		}
	},

	// ---- CREATE ----

	create(data, form) {
		$.ajax({
			url: api_base + '/users',
			method: 'POST',
			data: data,
			headers: {
				Accept: 'application/json'
			},

			success: function (res) {
				form.is_submited = false;
				router.go('/confirmacion-registro');
				// console.log(res);
			},

			error: function (err) {
				form.is_submited = false;

				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.responseJSON.email) {
					return toast({
						title: 'Registro',
						content: 'El email ya ha sido usado.'
					});
				}

				if (err.responseJSON.rfc) {
					return toast({
						title: 'Registro',
						content: 'El rfc ya ha sido tomado o es invalido'
					});
				}

				toast({
					title: 'Registro',
					content: 'Error al crear el usuario, intente de nuevo más tarde.'
				});

				// console.log(err);
			}
		});
	},

	// ---- DELETE ----

	delete(admin, user, cb) {
		$.ajax({
			url: api_base + '/admin/users/' + user.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + admin.token
			},

			success: function (res) {
				cb(res);

				toast({
					title: 'Eliminar Usuario',
					content: 'El usuario ' + res.name + ' ha sido removido.'
				});
			},

			error: function (err) {
				toast({
					title: 'Eliminar Usuario',
					content: 'Error al eliminar el usuario.'
				});

				// console.log(err);
			}
		});
	},

	// ---- UDPATE ----

	update(data, user, cb) {
		user._method = 'PUT';

		$.ajax({
			url: api_base + '/admin/users/' + user.id,
			method: 'POST',
			data: user,
			headers: {
				Authorization: 'Bearer ' + data.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Modificar Usuario',
					content: 'El usuario ' + user.name + ' ha sido actualizado.'
				});
				router.go({ name: 'admin_users' });
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Actualizar Usuario',
					content: 'Error al actualizar el usuario.'
				});

				// console.log(err);
			}
		})
	},

	// ---- UPDATE ME ----

	updateMe(user, cb) {
		user._method = 'PUT';

		$.ajax({
			url: api_base + '/users/me',
			method: 'POST',
			data: user,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Actualización de Perfil',
					content: 'Tu perfil se ha actualizado.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				if (err.responseJSON == 'La contrasena es incorrecta.') {
					return toast({
						title: 'Actualización de Perfil',
						content: 'La contraseña actual es incorrecta.'
					});
				}

				toast({
					title: 'Actualización de Perfil',
					content: 'El perfil no se ha actualizado.'
				});

				// console.log(err);
			}
		});
	},

	// ---- LOGIN ----

	login(encode, cb) {
		$.ajax({
			url: api_base + '/token',
			method: 'GET',
			headers: {
				Authorization: 'Basic ' + encode
			},

			success: function (res) {
				if (res.status == 'error') {
					return toast({
						title: 'Inicio de Sesión',
						content: res.message
					});
				}

				getShoppingCart(Store, res);
				getWishList(Store, res);
				setBillingInfo(Store, res);
				getUserOrders(Store, res);
				getUserPurchaseOrders(Store, res);
				cb(res, encode);
				// // Check if aren't orders in the store and the user has login is admin.
				// if(!Store.state.orders.length &&  res.user.user_type == 'admin') {
				// 	getOrders(Store, res);
				// }
				//  // Check if aren't sliders in the store and the user has login is admin.
				// if(!Store.state.sliders.length &&  res.user.user_type == 'admin') {
				// 	getSliders(Store, res);
				// }
				// // Check if aren't users in the store and the user has login is admin.
				// if (!Store.state.users.length && res.user.user_type == 'admin') {
				// 	getUsers(Store, res);
				// }
				// // Check if aren't projects in the store and the user has login is admin.
				// if (!Store.state.projects.length && res.user.user_type == 'admin') {
				// 	getContractProjects(Store, res);
				// }
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Login Usuario',
					content: 'Tu email o contraseña son incorrectos, por favor intenta de nuevo.'
				});
			}
		});
	},

	// ---- ME ----

	me(user, cb) {
		$.ajax({
			url: api_base + '/users/me',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				getShoppingCart(Store, user);
				getWishList(Store, user);
				setBillingInfo(Store, user);
				getUserOrders(Store, user);
				getUserPurchaseOrders(Store, user);
				cb(res);
				// // Check if aren't orders in the store and the user has login is admin.
				// if(!Store.state.orders.length &&  user.user_type == 'admin') {
				// 	getOrders(Store, user);
				// }
				//  // Check if aren't sliders in the store and the user has login is admin.
				// if(!Store.state.sliders.length &&  user.user_type == 'admin') {
				// 	getSliders(Store, user);
				// }
				// // Check if aren't users in the store and the user has login is admin.
				// if (!Store.state.users.length && user.user_type == 'admin') {
				// 	getUsers(Store, user);
				// }
				// // Check if aren't projects in the store and the user has login is admin.
				// if (!Store.state.projects.length && user.user_type == 'admin') {
				// 	getContractProjects(Store, user);
				// }
			},

			error: function (err) {
				logoutUser(Store, '/home');
				toast({
					title: 'Login Usuario',
					content: 'Sesión expirada (inicia sesión de nuevo)',
					duration: 5000
				});
			}
		});
	},

	// ---- VERIFY ----

	verify(token) {
		$.ajax({
			url: api_base + '/users/verificar-cuenta/' + token,
			method: 'GET',

			success: function (res) {
				router.go('/cuenta-verificada');
				// console.log(res);
			},

			error: function (err) {
				toast({
					title: 'Verificar usuario',
					content: 'Error al verificar al usuario.'
				});
				// console.log(err);
			}
		});
	},

	// ---- ADD RATING ----

	rate(user, rating, cb) {
		$.ajax({
			url: api_base + '/users/me/post/rating',
			method: 'POST',
			data: rating,
			headers: {
				'Authorization': 'Bearer ' + user.token,
				'Accept': 'application/json'
			},

			success: function (res) {
				cb(res);

				$('.close').trigger('click');

				if (res.status == 'error') {
					return toast({
						title: 'Comentar Producto',
						content: 'No puedes calificar sin haber comprado el producto',
						duration: 8000
					});
				}

				toast({
					title: 'Comentar Producto',
					content: 'Comentario agregado correctamente. Se mostrara en cuanto se apruebe el comentario.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				if (err.statusCode == 403) {
					toast({
						title: 'Comentar Producto',
						content: 'El producto ya ha sido comentado'
					});
				}

				if (err.statusCode == 422) {
					toast({
						title: 'Comentar Producto',
						content: 'El mensaje no puede tener mas de 255 caracteres.'
					});
				}

				if (err.responseJSON.rating) {
					return toast({
						title: 'Comentar Producto',
						content: 'Agrega rating al producto'
					});
				}

				toast({
					title: 'Comentar Producto',
					content: 'Tienes comprar el producto para calificarlo.'
				});
			}
		});
	},

	// ---- RECOVER PASS ----

	forgotPass(form) {
		$.ajax({
			url: api_base + '/users/sendResetPasswordEmail/' + form.email,
			method: 'GET',

			success: function (res) {
				toast({
					title: 'Recuperar contraseña',
					content: 'Se te ha enviado un correo, checa tu bandeja de entrada y spam.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Recuperar contraseña',
					content: 'Este correo no es valido.'
				});

				// console.log(err);
			}
		});
	},

	// ---- RESET PASS ----

	resetPass(form) {
		$.ajax({
			url: api_base + '/users/resetPassword',
			method: 'POST',
			data: form,
			headers: {
				Accept: 'application/json'
			},

			success: function (res) {
				router.go('/contrasena-reiniciada');
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Reinicio de contraseña',
					content: 'Error al actualizar la contraseña.'
				});
				// console.log(err);
			}
		});
	},
};



// WEBPACK FOOTER //
// ./src/store/api/users.js